// extracted by mini-css-extract-plugin
export default {"mark":"exclamationMark_mark__c9p6N","pulse":"exclamationMark_pulse__2oq7S"};